import { createReducer, createActions } from 'reduxsauce';
import Immutable from 'seamless-immutable';

/* Types & Action Creators */

const { Types, Creators } = createActions({
  setModuleRequest: ['module'],
  setModuleSuccess: ['module'],
  setModuleFailure: ['error'],
});

export const ModulesTypes = Types;
export default Creators;

/* Initial State */

export const INITIAL_STATE = Immutable({
  currentModule: null,
  isLoading: false,
  error: null,
});

/* Reducers */

const setModuleRequest = (state) =>
  state.merge({
    isLoading: true,
  });

const setModuleSuccess = (state, { module }) =>
  state.merge({
    currentModule: module,
    isLoading: false,
    error: null,
  });

const setModuleFailure = (state, { error }) =>
  state.merge({
    error,
    isLoading: false,
  });

/* Reducers to types */

export const reducer = createReducer(INITIAL_STATE, {
  [Types.SET_MODULE_REQUEST]: setModuleRequest,
  [Types.SET_MODULE_SUCCESS]: setModuleSuccess,
  [Types.SET_MODULE_FAILURE]: setModuleFailure,
});

